<div mat-dialog-title class="dialog-info">
    <label class="dialogTitle">
       {{'PUBLISH' |translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none crossButtonPosition" [mat-dialog-close]></button>
</div>

<mat-dialog-content class="contentPadding">
    <form [formGroup]="publishCollabFormGroup">
        <mat-form-field class="w-100 notes-container" appearance="outline">
            <mat-label class="bold">
                {{'PUBLISH_CHANGE_LOG_NOTES' | translate}}
            </mat-label>
            <textarea matInput
                rows="5"
                maxlength="400"
                formControlName="modificationNotes"
                placeholder="{{'PUBLISH_CHANGE_LOG_NOTES_PLACEHOLDER' | translate}}"></textarea>
            @if (publishCollabFormGroup.controls.modificationNotes.hasError('required')) {
                <mat-error>{{'NOTES_ARE_REQUIRED' | translate}}</mat-error>
            }
        </mat-form-field>
        <section class="publish-collab-section-checkbox">
            <mat-checkbox color="primary" formControlName="sendEmail">{{'NOTIFY_COLLABORATORS' | translate}}</mat-checkbox>
        </section>
    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <div>
        <button class="openCloseBtn" 
                mat-raised-button color="primary" 
                (click)="publish()" 
                [disabled]="publishCollabFormGroup.invalid">
                {{'PUBLISH' | translate}}
        </button>
        <button class="openCloseBtn"
                    mat-raised-button color="warn" 
                    [mat-dialog-close]>
                    {{'CANCEL' | translate}}
        </button>
    </div>
</mat-dialog-actions>